/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import ImprintPageMeta from "./ImprintPageMeta";
import Layout from "../../../Layouts/Layout";
import Imprint from "../../../../components/Imprint/Imprint";

const ImprintPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <ImprintPageMeta />
      <Imprint />
    </Layout>
  );
};

export default ImprintPage;
